const APIHOST = (process.env.NODE_ENV === "development") ? "https://www.christmaslistapp.com/api2" : "https://www.christmaslistapp.com/api2";

function handleErrors(response) {
    if (!response.ok) {
        throw response;
    }
    return response;
}

export function getToken(data) {
    console.log('GETTING TOKEN...', data);
    return fetch(APIHOST + "/tokens2", 
        {
            headers: {
                'X-Cla-Authorization': '',
                'Content-Type': 'application/json'
            },
            method: 'POST', 
            body: JSON.stringify(data) 
        })
        .then(handleErrors)
        .then(res => {
            return res.json();
        }).catch( err => {
            console.log('MY ERR', err);
            return err;
        });
    
}